import { html as staticHtml, unsafeStatic } from 'lit/static-html.js';
import { nothing } from 'lit';
import { headingWrapping } from '../components/headingWrapping.js';
import {
  resolveTypographySemanticTag,
  typographySemanticTag,
  type TypographySemanticTag,
} from '../../shared/editor/landingEditorTypography.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from './landingEditorRender.js';

interface EditorSemanticTextOptions {
  editor?: LandingEditorRenderOptions;
  elementId?: string;
  fallbackTag: TypographySemanticTag;
  className?: string;
  content: unknown;
}

export const editorSemanticTag = (
  editor: LandingEditorRenderOptions | undefined,
  elementId: string | undefined,
  fallbackTag: TypographySemanticTag,
): TypographySemanticTag =>
  resolveTypographySemanticTag(elementId ? editor?.project.elementFrames[elementId] : undefined, fallbackTag);

export const editorSemanticText = ({
  editor,
  elementId,
  fallbackTag,
  className = '',
  content,
}: EditorSemanticTextOptions) => {
  const semanticTag = editorSemanticTag(editor, elementId, fallbackTag);
  const tag = unsafeStatic(semanticTag);
  const heading = /^h[1-6]$/u.test(semanticTag) || /^h[1-6]$/u.test(fallbackTag);
  const assignedStyle = elementId ? editor?.project.elementFrames[elementId]?.typographyStyle : undefined;
  const semanticClass = typographySemanticTag(assignedStyle)
    ? `vp-editor-semantic-text vp-editor-semantic-${fallbackTag === 'p' ? 'paragraph' : 'heading'}`
    : '';
  const baseClass = `${semanticClass} ${className} ${heading ? 'vp-word-safe-heading' : ''}`.trim();
  const classes = elementId ? editorNodeClass(editor, elementId, baseClass) : baseClass;
  const style = elementId ? editorNodeStyle(editor, elementId) : '';
  return staticHtml`
    <${tag}
      class=${classes}
      style=${style}
      ${heading ? headingWrapping() : nothing}
      @pointerdown=${(event: PointerEvent) => elementId && editorNodePointerDown(editor, elementId, event)}
      @click=${(event: MouseEvent) => elementId && editorNodeClick(editor, elementId, event)}
    >${content}</${tag}>
  `;
};
